import { isCCA, ccaUserGroup, endUserGroup, Suspended } from '../constants';
import store from './store';

export const ADD_CONTRACT = 'STORE_CONTRACTS';

export const addContract = (payload) => {
  // FEATURE DISABLED (Release july-2026)
  // // Get current user's groups to determine filtering behavior
  // const userGroups = store.getState()?.userInfo?.userInfo?.SPGGroups || [];
  // const isCCAUser = userGroups.includes(ccaUserGroup);
  // const isEndUser = userGroups.includes(endUserGroup);
  //
  // // Filter out suspended contracts only for CCA and End Users
  // // CSA and Super Users will see all contracts including suspended ones
  // let filteredContracts = payload;
  // if (isCCAUser || isEndUser) {
  //   filteredContracts = payload.filter(
  //     (contract) => contract?.contractStatus !== Suspended
  //   );
  // }

  return {
    type: ADD_CONTRACT,
    payload: { contracts: payload, isCCAUser: isCCA },
  };
};
